import React from 'react'

import BackButton from '@components/BackButton'
import useMain from '@hooks/useMain'
import useNetwork from '@hooks/useNetwork'
import useNetworkWallet from '@hooks/useNetworkWallet'

import { PaymentsCheckout } from './components'

import { PaymentsContainer, PaymentsHeader } from './styles'

const Payments: React.FC = () => {
    const {
        state: {
            mainInit: { network },
        },
        operations: { reset: resetUseMain },
    } = useMain()
    const {
        operations: { reset: resetUseNetwork },
    } = useNetwork()
    const {
        operations: { reset: resetUseNetworkWallet },
    } = useNetworkWallet()

    const handleGoBack = React.useCallback(() => {
        resetUseMain()
        resetUseNetwork()
        resetUseNetworkWallet()
    }, [])

    if (network) {
        return (
            <>
                <PaymentsHeader as="header">
                    <BackButton handleClick={handleGoBack} message={'Back'} hasCaret />
                </PaymentsHeader>
                <PaymentsContainer>
                    <PaymentsCheckout />
                </PaymentsContainer>
            </>
        )
    }

    return (
        <>
            <h1>NO NETWORK</h1>
        </>
    )
}

export default Payments
